import React from "react";

export default function AydinlatmaMetni() {
  return (
    <div
      style={{
        marginTop: "50px",
        padding: "30px",
        fontFamily: "Arial, sans-serif",
        color: "#333",
      }}
    >
      <hr style={{ margin: "40px 0" }} />

      <h2 style={{ color: "#2F2C6A" }}>Aydınlatma Metni</h2>
      <p>
        <strong>Veri Sorumlusu:</strong> [SOFTANA]
      </p>
      <p>
        <strong>İletişim:</strong> [info@softana.com.tr]
      </p>

      <p>
        İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu
        (“KVKK”) kapsamında, kullanıcılarımızın kişisel verilerinin işlenmesine
        ilişkin olarak bilgilendirme amacıyla hazırlanmıştır.
      </p>

      <h4>1. İşlenen Veriler</h4>
      <p>
        Ad, soyad, cep telefonu numarası, işletme adı, e-posta gibi kimlik ve
        iletişim bilgileri.
      </p>

      <h4>2. Veri İşleme Amaçları</h4>
      <ul>
        <li>Hizmet sunumu</li>
        <li>İletişim faaliyetlerinin yürütülmesi</li>
        <li>Geri bildirimlerin değerlendirilmesi</li>
        <li>Platformun geliştirilmesi</li>
      </ul>

      <h4>3. Hukuki Sebep</h4>
      <p>
        Kişisel veriler, açık rıza ve/veya KVKK madde 5/2 kapsamında hukuki
        yükümlülüklerin yerine getirilmesi amacıyla işlenir.
      </p>

      <h4>4. Veri Aktarımı</h4>
      <p>
        Kişisel veriler, yasal zorunluluklar haricinde 3. şahıslarla
        paylaşılmaz.
      </p>

      <h4>5. Haklarınız</h4>
      <ul>
        <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
        <li>İşlenmişse bilgi talep etme</li>
        <li>İşleme amacını ve uygun kullanılıp kullanılmadığını öğrenme</li>
        <li>Silinmesini veya anonimleştirilmesini isteme</li>
      </ul>

      <h4>6. Başvuru</h4>
      <p>
        KVKK kapsamındaki haklarınızı kullanmak için [destek@siteadresi.com]
        adresine başvurabilirsiniz.
      </p>
    </div>
  );
}
